import { AdjustmentType } from '@g2-shared/api-client/generated/settlement-app';

export const AdjustmentTypeLabelMapper: Record<AdjustmentType, string> = {
  [AdjustmentType.REPROCESSED]: 'Reprocessed',
  [AdjustmentType.REVERSED]: 'Reversed',
  [AdjustmentType.REVERSED_AND_THEN_REPROCESSED]: 'Reversed_and_reprocessed',
};
